import styled from 'styled-components'

import { color, media, spacing } from '../../themes'

export const CheckboxRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & label {
    padding: ${spacing(3, 0)};
  }

  ${media.tablet} {
    width: 382px;
  }
`

export const Container = styled.div`
  ${CheckboxRow} {
    padding-top: ${spacing(2)};
    margin-top: ${spacing(2)};
    border-top: 1px solid ${color('gray.05')};

    &:first-child {
      padding-top: 0;
      margin-top: 0;
      border-top: none;
    }
  }
`

export const ChildCheckboxRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & label {
    padding: ${spacing(1.5, 0)};
  }
`

export const ChildGroupContainer = styled.div`
  background: ${color('offWhite')};
  padding: ${spacing(3, 2)};

  ${ChildCheckboxRow} {
    margin-top: ${spacing(2)};

    &:first-child {
      margin-top: 0;
    }
  }
`

export const ExpandButton = styled.button<{ open: boolean }>`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: ${color('gray.02')};
  height: 48px;
  min-width: 48px;

  & svg {
    transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: all 0.3s ease;
  }
`
